import React from "react";
import { cn } from "../../../../helper/utilityHelper";
import PremiumIcon from "../classic/Premium-Icon";
import PremiumBadge from "../classic/Premium-Badge";

const MenuLabel = ({ item, className }) => {
  const { title, isPremium } = item;
  return (
    <div
      className={cn(
        "text-default-900 font-semibold uppercase mb-1 text-xs  mt-2",
        className
      )}
    >
      {title}
      {/* {isPremium && <span className="ml-4"><PremiumBadge /></span>}*/}
      {isPremium && <span className="ml-20 align-middle"><PremiumIcon /></span>}

    </div>
  );
};

export default MenuLabel;
